import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionStatus } from '../../enums';
import { SubscriptionStatusPipe } from '../../pipes';

@Component({
  selector: 'app-subscription-status',
  imports: [CommonModule, SubscriptionStatusPipe],
  templateUrl: './subscription-status.component.html',
  styleUrl: './subscription-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionStatusComponent {
  public readonly status = input.required<SubscriptionStatus>();

  protected readonly cssClass = computed(() => {
    switch (this.status()) {
      case SubscriptionStatus.Active:
        return 'text-lime-600';

      case SubscriptionStatus.Suspended:
        return 'text-yellow-500';

      case SubscriptionStatus.Cancelled:
        return 'text-rose-700';

      default:
        return '';
    }
  });
}
